import Core from "../core";

function updateAboutMe(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .put(`/v1/employee/updateAboutMe`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updatePersonalInfo(empId: number, payload: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .post(
        `/v1/employee/employeePersonalDetails?emp_id=${empId}&locale=${localStorage.getItem(
          "emplang"
        )}`,
        payload
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function updateJobInfo(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/employee/employeeJobInfo`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function updateBankDetail(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/addBankDetails`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateEmergencyContact(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/employee/emergencyContact`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function addEmployeeSkill(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/employee/addEmployeeSkill`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateEmployeeSkill(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .put(`/v1/employee/updateEmployeeSkill`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function deleteEmployeeSkill(empId: number, skill_id: number) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .delete(`/v1/employee/deleteEmployeeSkill?id=${skill_id}&empId=${empId}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function updatePassword(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .put(`/v1/employee/updatePassword`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const updatePersonalDetailsService = {
  updatePersonalInfo,
  updateJobInfo,
  updateBankDetail,
  updateEmergencyContact,
  updateAboutMe,
  deleteEmployeeSkill,
  updateEmployeeSkill,
  addEmployeeSkill,
  updatePassword,
};
